<template>
  <img class="blueberry-icon" :src="require(`../../public/icons/${name}.svg`)" :alt="name">
</template>

<script>
export default {
  name: 'BlueberryIcon',
  props: {
    name: String
  }
}
</script>

<style lang="scss">
.blueberry-icon {
  width: 20px;
  height: 20px;
  margin-right: 15px;
}
</style>